export const messages = {
  en: {
    storeOrderUpManage: {
      title: 'Pending Orders',
      orderId: 'Order ID',
      customerName: 'Customer Name',
      totalPrice: 'Total Price',
      orderStatus: 'Order Status',
      remarks: 'Remarks',
      createTime: 'Create Time',
      operations: 'Operations',
      select: 'Select',
      delete: 'Delete',
      back: 'Back',
      deleteConfirm: 'Confirm to delete this order?',
      deleteSuccess: 'Order deleted successfully',
      deleteFailed: 'Failed to delete order'
    }
  },
  zh: {
    storeOrderUpManage: {
      title: '挂单信息',
      orderId: '订单编号',
      customerName: '用户名称',
      totalPrice: '订单总价',
      orderStatus: '订单状态',
      remarks: '订单备注',
      createTime: '挂单时间',
      operations: '操作',
      select: '选择',
      delete: '删除',
      back: '返回',
      deleteConfirm: '确定删除该订单吗？',
      deleteSuccess: '订单删除成功',
      deleteFailed: '订单删除失败'
    }
  }
}